export const validateUser = (userTypes, type) => userTypes.filter(currentType => currentType === type).length > 0
